/*=================================================
    summary: 複習 寫一寫        LUSeqNo: 22
             Review Writing Composition

    remarks: 000 Tim 2021/12/30 Create
             001 Tim 2022/01/14 串接 LanguageChangeHandler 流程
=================================================*/
import React, { useEffect, useRef } from 'react'
import cssReviewWritingComposition from './ReviewWritingComposition.module.scss'

import CompositionMain from '../Component/CompositionMain/CompositionMain'
import { ExecuteActionEnum } from '../Component/CompositionContent/CompositionContent';

const COMP_NAME = "ReviewWritingComposition"

// #region Member Variables
let mblnInitialized = false
let mfuncLanguageChangeHandler = null
let mfuncExecuteCompositionMainAction = null
// #endregion Member Variables

function ReviewWritingComposition(props) 
{
    console.log(COMP_NAME + ".Begin:", props)

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized) 
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        mblnInitialized = true
    }
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mblnInitialized = false
            mfuncLanguageChangeHandler = null       // 這邊離開 會 移除 所以 CompositionMain 不做反註冊  Tim22.01.14
            mrefCleanUp.current()
        }
    }, [props.LUInfo])
    // #endregion useEffect

    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Jeff 2022/01/13 Create  Tim幫忙註解
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")

        RegisterLanguageChangeHandler()
        RegisterGlossaryCallback()
    } // end of PaintedMe

    /*===========================================
    summary: componentWillUnmount 程式離開 處理離開流程
    remarks: 000 Jeff 2022/01/13 Create  Tim幫忙註解
    ===========================================*/
    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")
        mfuncExecuteCompositionMainAction = null
        UnregisterLanguageChangeHandler()
        UnregisterGlossaryCallback()
    } // end of CleanUp
    // #endregion Painted Me

    // #region Other Handler
    /*===========================================
    summary: 語言設定 改變 事件
    remarks: 000 Jeff 2022/01/13 Create    Tim幫忙註解
             001 Tim 2022/01/14 實作內容
    ===========================================*/
    function LanguageOnChangeHandler()
    {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")

        if (mfuncLanguageChangeHandler !== null)
        {
            mfuncLanguageChangeHandler()
        }
    } // end of LanguageOnChangeHandler
    // #endregion Other Handler

    // #region Component Callback
    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "RegisterLanguageChangeHandler")
        {
            mfuncLanguageChangeHandler = CallbackObj.Function
        }
        else if(CallbackObj.Action === "RegisterExecuteCompositionMainAction")
        {
            mfuncExecuteCompositionMainAction = CallbackObj.Function
        }
        else
        {
            // 其他 事件 直接往上送
            props.CallbackRef(CallbackObj)
        }
    } // end of ComponentCallback

    function GlossaryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".GlossaryWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowGlossary")
        {
            console.log("GlossaryWindowCallback.CloseShowGlossary")
            mfuncExecuteCompositionMainAction(ExecuteActionEnum.RegisterAudioEvent) // 因為開啟GlossaryWindow時 Audio Event被註冊過去 所以關閉GlossaryWindow時 要再註冊回此
        }
    }

    // #endregion Component Callback

    // #region Other Functions

    function RegisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".RegisterGlossaryCallback: ")
        // 因為ToolBarTopUnit點擊Glossary開啟後 會搶走AudioEnded, AudioCanPlay事件 所以如果LU有使用Audio Event 就必須在Glossary關閉時 需呼叫mobjCallerInfoForGlossaryWindow.CallbackRef 觸發 讓Audio Event再次註冊到LU
        let objCallbackData = {
            "Action": "RegisterGlossaryCallback",
            "CallbackRef": GlossaryWindowCallback
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".UnregisterGlossaryCallback: ")
        let objCallbackData = {
            "Action": "UnregisterGlossaryCallback"
        }
        props.CallbackRef(objCallbackData)
    } 

    /*===========================================
    summary: 註冊 語言改變事件
    remarks: 000 Jeff 2022/01/13 Create  Tim幫忙註解
    ===========================================*/
    function RegisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    } // end of RegisterLanguageChangeHandler

    /*===========================================
    summary: 反註冊 語言改變事件
    remarks: 000 Jeff 2022/01/13 Create  Tim幫忙註解
    ===========================================*/
    function UnregisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    } // end of UnregisterLanguageChangeHandler
    // #endregion Other Functions

    // #region Render
    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/12/30 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssReviewWritingComposition.divMain}>
                <CompositionMain LUInfo={props.LUInfo} 
                    LessonID={props.LessonID}
                    SubSectionDef={props.SubSectionDef}
                    GoToLUSinceAction={props.GoToLUSinceAction}
                    CallbackRef={ComponentCallback}/>
            </div>
        )
    } // end of RenderMainWrapper

    return (
        <>        
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default ReviewWritingComposition